

















import { Component, Vue, Prop } from 'vue-property-decorator';

import { Picture } from '../components';
import Stars from './components';

import { StringOrNumber } from '@/pages/profile/utils';
import { IReview } from './types';

@Component({
  components: { Stars, Picture },
})
export default class Review extends Vue implements IReview {
  @Prop({ type: [String, Number], default: '' })
  id: StringOrNumber;

  @Prop({ type: String, default: '' })
  img: string;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: String, default: '' })
  date: string;

  @Prop({ type: [String, Number], default: '0' })
  rating: StringOrNumber;

  get link(): string {
    return `/program/${this.id}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/review/Review.vue